import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "../private/PrivateRoute";
import PublicRoute from "../private/PublicRoute";
import { privateRoutes, publicRoutes } from "../constant";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import MainLayout from "../layout/MainLayout";

const AllRoutes = () => {
  return (
    <>
      <Routes>
        {/* Private Routes with per-route role-based access */}
        {privateRoutes.map(({ path, element, roles, showLayout = true }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute role={roles}>
                {showLayout ? <MainLayout>{element}</MainLayout> : element}
              </ProtectedRoute>
            }
          />
        ))}

        {/* public routes */}
        {publicRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={<PublicRoute>{element}</PublicRoute>} />
        ))}
        <Route path="/" element={<Home />} />
        {/* <Route path="/unauthorized" element={<Unauthorized />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AllRoutes;
